export const routesConfig = [
  { path: "/home", title: "Home" },
  { path: "/insights", title: "Insights" },
  { path: "/surveys", title: "Assessments" },
  { path: "/collect", title: "Collectors" },
  { path: "/projects", title: "Projects" },
  { path: "/help", title: "Help Center" },
  { path: "/account/profile", title: "Account Settings" },
  { path: "/account/subscription", title: "Subscription" },
  { path: "/account/manage-users", title: "Manage Users" },
];
